enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export default SortDirection;
